<template>
  <router-link
    v-if="routerLink"
    :to="getLinkBuilder(item)"
    class="LKMunMehForm__content__link"
  >
    <FormRow v-bind="attrs" />
  </router-link>
  <FormRow v-else-if="item" v-bind="attrs" />
</template>

<script>
import FormRow from '@/views/LKMunMeh/HostView/components/LKMunMehHostViewRow.vue'

export default {
  name: 'LKMunMehHostViewLink',
  components: { FormRow },
  props: {
    item: Object,
    idx: [String, Number],
    getLinkBuilder: Function,
    bold: Boolean,
    marksHidden: Boolean,
  },
  computed: {
    routerLink() {
      return this.getLinkBuilder && this.item?.max_score > 0
    },
    attrs() {
      const {
        idx, bold, item, marksHidden,
      } = this
      return {
        idx,
        item,
        bold,
        marksHidden,
      }
    },
  },
}
</script>

<style lang="scss">
.text-right {
  text-align: end;
}

.LKMunMehForm__content__link .LKMunMehFormRow {
  padding: 0 6px;
  margin: -10px -16px;
  transition: background 0.3s ease;

  &:hover {
    background: $background-gray;
  }
}
</style>
